import { Route, Switch } from 'react-router-dom';
import MyIDPage from './MyID';

export const MyIdIndex = () => {
  return (
    <Switch>
      <Route path='/' component={MyIDPage} />
    </Switch>
  );
};
